/**
 * s732: слышимый знак «вас соединили».
 *
 * Браузер менеджера снимает трубку САМ (ТЗ §2.2) — и до сих пор делал это беззвучно. Станция
 * соединяла клиента, а менеджер, не глядя в экран, об этом не знал: 08.10.2026 в четырёх
 * автоматических перезвонах из пяти клиент сказал «алло» в тишину и положил трубку через
 * 7–16 секунд (звонки №956, 961, 963, 969; в записи на стороне менеджера — ни слова).
 *
 * Знак звучит только у менеджера, в его наушниках или колонках, — в разговор он не подмешан.
 * Короткий, двухтонный, не похож на гудок: «трубка уже снята, говорите».
 */
export function signalSoedineniya(): void {
  try {
    const Ctor = window.AudioContext
      ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;

    if (!Ctor) return;

    const ctx = new Ctor();
    const now = ctx.currentTime;

    ([[880, 0, 0.13], [1320, 0.15, 0.2]] as const).forEach(([freq, at, dur]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();

      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, now + at);
      gain.gain.exponentialRampToValueAtTime(0.25, now + at + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + at + dur);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now + at);
      osc.stop(now + at + dur + 0.02);
    });

    window.setTimeout(() => { void ctx.close().catch(() => undefined); }, 900);
  } catch {
    // Браузер запретил звук — экран всё равно показывает звонок.
  }
}
